export const ScheduledMessageConstants = {
  generic: {
    title: 'MESSAGETIPS.GLOBAL.GENERICSTATE',
    subtitle: 'MESSAGETIPS.GLOBALSCHEDULED.GENERICSTATE',
  },
  first_booking: {
    title: 'MESSAGETIPS.GLOBAL.FIRSTBOOKING',
    subtitle: 'MESSAGETIPSV2.GLOBALSCHEDULE.SUBTITLE',
  },
  completed_session_next_booking_incentive: {
    title: 'MESSAGETIPSV2.GLOBAL.SESSION_COMPLETED',
    subtitle: 'MESSAGETIPSV2.GLOBALSCHEDULE.SUBTITLE',
  },
  missed_session_next_booking_incentive: {
    title: 'MESSAGETIPSV2.GLOBAL.SESSION_CANCELLED',
    subtitle: 'MESSAGETIPSV2.GLOBALSCHEDULE.SUBTITLE',
  },
};
